import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router";
import { filters, helpers } from "../../store";

class Loading extends React.Component {
	componentDidMount() {
		this.props.setRoute(
			this.props.history.location.pathname.replace(/\//u, "")
		);
		this.props.setFilters(this.props.location.search);
	}

	render() {
		return <span />;
	}
}

const mapStateToProps = state => ({
	...state.helpers,
	filters: state.filters
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			setFilters: filters.setFilters,
			setUrlQuery: filters.setUrlQuery,
			setRoute: helpers.setRoute
		},
		dispatch
	);

Loading.propTypes = {
	history: PropTypes.object.isRequired,
	setRoute: PropTypes.func.isRequired
};

export default withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(Loading)
);
